module.exports = __webpack_public_path__ + "static/media/portfolio3.ce79413f.jpg";